import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import "../../../style/punchinpuchout.css";

export default function AbsenceDetails({ plannedList = [] }) {
  const history = useHistory();
  const today = new Date();

  const formattedDate = today.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  const absences = useMemo(() => {
    if (!plannedList.length) return [];

    return plannedList.map(item => {
      let leaveDayType = "Full Day";

      // Optional: adjust if your system supports half-day
      if (item.fromType === 2 || item.toType === 2 || item.noOfDays === 0.5) {
        leaveDayType = "Half Day";
      }

      return {
        name: item.employeeName,
        type: `${item.leaveType} ${leaveDayType}`
      };
    });
  }, [plannedList]);

  const handleClick = () => {
    history.push("/LeaveCalendar");
  };

  return (
    <div className="card absence-card">
     <div className="d-flex align-items-start gap-3 mb-3">

  {/* Icon */}
  <div className="icon-box bg-danger-light">
    <i className="fas fa-user-times text-danger"></i>
  </div>

  {/* Title + Subtitle */}
  <div>
    <h5 className="mb-1 fw-semibold">
      Absence Details
    </h5>
    <p className="text-muted small mb-0">
      {formattedDate} · Employee Absence Calendar
    </p>
  </div>

</div>

      <div className="absence-list">
        {absences.length === 0 ? (
          <div className="text-muted">No absences today</div>
        ) : (
          absences.map((a, i) => (
            <div key={i} className="absence-item">
              <span>{a.name}</span>
              <span className="badge">{a.type}</span>
            </div>
          ))
        )}
      </div>

      <div className="absence-total">
        Total Absences: {absences.length}
      </div>
      <br/>
      <button className="primary-btn" onClick={handleClick}>
        Leave Calendar
      </button>
    </div>
  );
}
